import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './HomePage';
import PlantSearch from './PlantSearch';
import PlantDetails from './PlantDetails';
import Header from './Header';
import SubmitSale from './SubmitSale';
import SpottedInTheWild from './SpottedInTheWild';
import Blog from './Blog';
import BlogPost from './BlogPost';
import AdminDashboard from './AdminDashboard';
import About from './About';
import TissueCulture from './TissueCulture';
import PlantsPage from './PlantsPage';
import SellerAuth from './SellerAuth';
import SellerDashboard from './SellerDashboard';
import ForSale from './ForSale';
import ResetPassword from './ResetPassword';
import SellerStorefront from './SellerStorefront';
import ListingDetail from './ListingDetail';
import './App.css';
import Footer from './Footer';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<PlantSearch />} />
          <Route path="/plant/:slug" element={<PlantDetails />} />
          <Route path="/plant-details/:plantName" element={<PlantDetails />} />
          <Route path="/submit" element={<SubmitSale />} />
          <Route path="/spotted" element={<SpottedInTheWild />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/about" element={<About />} />
          <Route path="/tissue-culture" element={<TissueCulture />} />
          <Route path="/plants" element={<PlantsPage />} />
          <Route path="/seller/login" element={<SellerAuth />} />
          <Route path="/seller/signup" element={<SellerAuth />} />
          <Route path="/seller/dashboard" element={<SellerDashboard />} />
          <Route path="/for-sale" element={<ForSale />} />
          <Route path="/shop/:businessSlug" element={<SellerStorefront />} />
          <Route path="/listing/:listingId" element={<ListingDetail />} />
          <Route path="/listing/:listingId/:listingSlug" element={<ListingDetail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;